import {
	createApp
} from 'vue'
import router from './router';
import App from './App.vue'
import './res/style/echarts.less';
import './res/style/reset.less';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import 'element-plus/dist/index.css';
import 'element-plus/theme-chalk/dark/css-vars.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import Socket from './res/javascript/socket.js';
import * as echarts from 'echarts';

const whiteList = ['/login', '/register', '/forgot'];

router.beforeEach(async (to, from, next) => {
	const hasToken = localStorage.getItem('token');
	if (hasToken) {
		if (to.path === '/login') {
			next('/');
		} else {
			next();
		}
	} else {
		if (whiteList.indexOf(to.path) !== -1) {
			next();
		} else {
			next('/login');
		}
	}
});

const app = createApp(App);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	app.component(key, component);
}

app.use(ElementPlus, {
	locale: zhCn
}).use(router);

app.config.globalProperties.$paymentURL = 'https://home.ddpaas.com/s';
app.config.globalProperties.$globalTitle = '资产管理系统';
// 根据环境切换 WS 地址
const hostname = window.location.hostname;
let wssURl = '';
let ysUserOption = false;

if (hostname.includes('yaosheng')) {
	ysUserOption = true;
	// wssURl = 'wss://living.ddpaas.com:5998';
	wssURl = 'wss://living.ddpaas.com:5997';
} else {
	// wssURl = 'wss://living.ddpaas.com:5997';
	wssURl = 'wss://iothz1.ddpaas.com:5997';
}

// ==============================================
// 全局只创建一次 Socket 实例
// ==============================================
const socket = new Socket(wssURl, {
	getToken: () => localStorage.getItem('token'),
});

app.config.globalProperties.$socket = socket;
app.config.globalProperties.$ysUserOption = ysUserOption;

// ==============================================
// 只在有 token 时连接一次
// ==============================================
const token = localStorage.getItem('token');
if (token) {
	console.log('初始化 Socket 连接');
	socket.connect();
}

// ==============================================
// 登录进入页面时更新 Token 并重连
// ==============================================
router.afterEach((to, from) => {
	const hasToken = !!localStorage.getItem('token');

	// 从登录页跳进来 → 更新 Token
	if (from.path === '/login' && to.path !== '/login' && hasToken) {
		console.log('从登录页进入，更新 Socket Token');
		socket.updateTokenAndReconnect();
	}
});

// ==================== 主题 ====================
import theme_00 from '@/res/echarts/theme/theme_00'
import theme_01 from '@/res/echarts/theme/theme_01'
import theme_02 from '@/res/echarts/theme/theme_02'
import theme_03 from '@/res/echarts/theme/theme_03'
import theme_04 from '@/res/echarts/theme/theme_04'
import theme_05 from '@/res/echarts/theme/theme_05'
import theme_06 from '@/res/echarts/theme/theme_06'
import theme_07 from '@/res/echarts/theme/theme_07'
import theme_08 from '@/res/echarts/theme/theme_08'

const CURRENT_THEME = 'theme_08';
let THEME_COLOR = [];

if (CURRENT_THEME == 'theme_00') {
	echarts.registerTheme('theme', theme_00)
	THEME_COLOR = ['rgba(10, 188, 255, 1)', 'rgba(254, 173, 19, 1)', 'rgba(1, 254, 183, 1)', 'rgba(13, 142, 255, 1)',
		'rgba(223, 255, 0, 1)', 'rgba(3, 203, 235, 1)', 'rgba(255, 0, 170, 1)', 'rgba(10, 255, 255, 1)',
		'rgba(255, 146, 100, 1)', 'rgba(0, 176, 255, 1)'
	]
} else if (CURRENT_THEME == 'theme_01') {
	echarts.registerTheme('theme', theme_01)
	THEME_COLOR = ['rgba(10, 188, 255, 1)', 'rgba(252, 105, 70, 1)', 'rgba(253, 184, 49, 1)', 'rgba(71, 197, 146, 1)',
		'rgba(43, 143, 211, 1)', 'rgba(1, 254, 183, 1)', 'rgba(212, 42, 82, 1)', 'rgba(218, 249, 4, 1)',
		'rgba(185, 20, 254, 1)', 'rgba(243, 195, 122, 1)'
	]
} else if (CURRENT_THEME == 'theme_02') {
	echarts.registerTheme('theme', theme_02)
	THEME_COLOR = ['rgba(255, 173, 18, 1)', 'rgba(0, 219, 252, 1)', 'rgba(18, 195, 176, 1)', 'rgba(248, 133, 130, 1)',
		'rgba(254, 221, 0, 1)', 'rgba(12, 143, 255, 1)', 'rgba(226,49,222, 1)', 'rgba(231, 107, 16, 1)',
		'rgba(8,245,219, 1)', 'rgba(240,57,83, 1)'
	]
} else if (CURRENT_THEME == 'theme_03') {
	echarts.registerTheme('theme', theme_03)
	THEME_COLOR = ['rgba(0, 242, 255, 1)', 'rgba(235, 169, 77, 1)', 'rgba(33, 217, 140, 1)', 'rgba(230, 108, 69, 1)',
		'rgba(158, 124, 244, 1)', 'rgba(0, 105, 249, 1)', 'rgba(248, 133, 130, 1)'
	]
} else if (CURRENT_THEME == 'theme_04') {
	echarts.registerTheme('theme', theme_04)
	THEME_COLOR = ['rgba(0, 242, 255, 1)', 'rgba(235, 169, 77, 1)', 'rgba(33, 217, 140, 1)', 'rgba(230, 108, 69, 1)',
		'rgba(158, 124, 244, 1)', 'rgba(0, 105, 249, 1)', 'rgba(248, 133, 130, 1)'
	]
} else if (CURRENT_THEME == 'theme_05') {
	echarts.registerTheme('theme', theme_05)
	THEME_COLOR = ['rgba(0, 242, 255, 1)', 'rgba(235, 169, 77, 1)', 'rgba(33, 217, 140, 1)', 'rgba(230, 108, 69, 1)',
		'rgba(158, 124, 244, 1)', 'rgba(0, 105, 249, 1)', 'rgba(248, 133, 130, 1)'
	]
} else if (CURRENT_THEME == 'theme_06') {
	echarts.registerTheme('theme', theme_06)
	THEME_COLOR = ['rgba(0, 112, 255, 1)', 'rgba(49, 235, 157, 1)', 'rgba(254, 81, 81, 1)', 'rgba(255, 238, 65, 1)',
		'rgb(102, 0, 255, 1)', 'rgba(61, 248, 253, 1)', 'rgba(180, 225, 75, 1)', 'rgba(255, 238, 65, 1)',
		'rgba(255, 146, 100, 1)', 'rgba(0, 176, 255, 1)', 'rgba(255, 68, 157, 1)'
	]
} else if (CURRENT_THEME == 'theme_07') {
	echarts.registerTheme('theme', theme_07)
	THEME_COLOR = ['rgba(0, 242, 255, 1)', 'rgba(235, 169, 77, 1)', 'rgba(33, 217, 140, 1)', 'rgba(230, 108, 69, 1)',
		'rgba(158, 124, 244, 1)', 'rgba(129, 83, 255, 1)', 'rgba(248, 133, 130, 1)'
	]
} else if (CURRENT_THEME == 'theme_08') {
	echarts.registerTheme('theme', theme_08)
	THEME_COLOR = ['rgba(25, 104, 255, 1)', 'rgba(117, 240, 194, 1)', 'rgba(158, 124, 244, 1)', 'rgba(204, 210, 66, 1)',
		'rgba(255, 83, 83, 1)', 'rgba(255, 189, 83, 1)', 'rgba(73, 204, 239, 1)', 'rgba(255, 39, 214, 1)',
		'rgba(84, 112, 222, 1)'
	]
}

app.config.globalProperties.$THEME = CURRENT_THEME;
app.config.globalProperties.$THEME_COLOR = THEME_COLOR;

app.mount('#app');